import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "../../../assets/css/customer/home/LandingPage.css";
import MyNavbar from "../../../components/customer/navigationbar/MyNavbar";
import ScrollToTopButton from "../../../components/customer/scrollbutton/ScrollToTopButton";
import CategoryShowcase from "../../../subscreen/customer/category/CategoryShowcase";
import Footer from "../../../subscreen/customer/footer/Footer";
import OurStory from "../../../subscreen/customer/ourStory/OurStory";
import PopularProducts from "../../../subscreen/customer/popularProducts/PopularProduct";
import Reviews from "../../../subscreen/customer/review/Review";

// Category icons
import Armchair from "../../../assets/images/armchair_icon.png";
import Barstand from "../../../assets/images/bar_icon.png";
import Bedroom from "../../../assets/images/bed_icon.png";
import BookCase from "../../../assets/images/bookstand_icon.png";
import Chair from "../../../assets/images/chair_icon.png";
import Kitchen from "../../../assets/images/kitchen_icon.png";
import Office from "../../../assets/images/office_icon.png";
import Sofa from "../../../assets/images/sofa_icon.png";
import Table from "../../../assets/images/table_icon.png";
import Wardrobe from "../../../assets/images/wardrobe_icon.png";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image:
        "https://plus.unsplash.com/premium_photo-1670076505419-99468d952c61?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      title: "AD Furniture House",
      subtitle: "Modern furniture crafted for comfort & style.",
      description: "Discover elegant designs that turn your house into a home.",
      buttonText: "Shop Now",
      buttonStyle: "outline",
      buttonPath: "/products",
    },
    {
      image:
        "https://i.pinimg.com/1200x/83/f4/52/83f452969b99a86fc23fa608204998e3.jpg",
      title: "AD Furniture House",
      subtitle: "Where relaxation meets timeless design",
      description:
        "Create your perfect bedroom with furniture made for peaceful living.",
      buttonText: "Explore Bedroom",
      buttonStyle: "solid",
      buttonPath: "/products",
    },
    {
      image:
        "https://i.pinimg.com/1200x/34/2b/6b/342b6bf2a1c74ddd2fe370be75d07cf6.jpg",
      title: "AD Furniture House",
      subtitle: "From kitchen to wardrobe — we've got you covered",
      description:
        "Functional, stylish, and built to last for every space in your home.",
      buttonText: "View Collections",
      buttonStyle: "outline",
      buttonPath: "/products",
    },
  ];

  const categories = [
    { name: "BEDROOM", icon: Bedroom },
    { name: "CHAIR", icon: Chair },
    { name: "SOFA", icon: Sofa },
    { name: "KITCHEN", icon: Kitchen },
    { name: "ARM CHAIR", icon: Armchair },
    { name: "WARDROBE", icon: Wardrobe },
    { name: "BAR SETS", icon: Barstand },
    { name: "OFFICE", icon: Office },
    { name: "DINING TABLES", icon: Table },
    { name: "BOOKCASE", icon: BookCase },
  ];

  const categorySliderSettings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    cssEase: "ease-in-out",
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 5, slidesToScroll: 1 } },
      { breakpoint: 992, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      // FIXED: was 2 — now 3 fits cleanly with smaller icons on mobile
      { breakpoint: 480, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    ],
  };

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(slideInterval);
  }, [slides.length]);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const prevSlide = () =>
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <Container fluid className="px-0">
      <MyNavbar />
      <ScrollToTopButton />

      <div className="landing-page">
        {/* Hero Slider */}
        <div className="hero-slider">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`hero-slide ${index === currentSlide ? "active" : ""}`}
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="hero-overlay"></div>
              <div key={currentSlide} className="hero-content">
                <h1 className="hero-title">{slide.title}</h1>
                <p className="hero-subtitle">{slide.subtitle}</p>
                <p className="hero-description">{slide.description}</p>
                <button
                  className={`hero-button ${slide.buttonStyle}`}
                  onClick={() => {
                    navigate(slide.buttonPath);
                  }}
                >
                  {slide.buttonText}
                </button>
              </div>
            </div>
          ))}
          <button className="slider-arrow prev" onClick={prevSlide}>
            ❮
          </button>
          <button className="slider-arrow next" onClick={nextSlide}>
            ❯
          </button>
        </div>

        {/* Category Icons Carousel */}
        <div className="category-section">
          <div className="category-carousel-wrapper">
            <Slider {...categorySliderSettings}>
              {categories.map((category, index) => (
                <div key={index} className="category-slide">
                  <div className="category-item">
                    <img
                      className="category-icon"
                      src={category.icon}
                      alt={category.name}
                    />
                    <p className="category-name">{category.name}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>

      <PopularProducts />
      <CategoryShowcase />
      <Reviews />
      <OurStory />
      <Footer />
    </Container>
  );
};

export default LandingPage;
